export default __webpack_public_path__ + "media/images/logo_white_background-55491380.png";